export default __webpack_public_path__ + "static/media/malev.572fe842.jpg";